import SaveQuotationHiring from '../SaveQuotationHiring'

export default class SaveQuotationRequest {
  /** (UUID): Identificador único de la cotización. */
  quotationId!: string

  /** Objeto que contiene información sobre la contratación. */
  hiring!: SaveQuotationHiring

  constructor(data: any) {
    this.quotationId = data.quotationId
    if (data.hiring) this.hiring = new SaveQuotationHiring(data.hiring)
  }
}
